<template>
  <div>
    <v-container fill-height fluid>
      <v-row>
        <v-col cols="12" class="pa-0" xs="12" md="12">
          <Loader v-if="profileLoading" class="mr-2 mt-6" loaderType="card-avatar, article, actions" />
          <v-card v-else class="pa-2 mr-2" outlined>
            <v-row class="mx-2 mb-3">
              <v-col xs="12" md="6">
                <v-card-title>
                  <div class="d-flex flex-column">
                    <div class="my-2 ml-2">
                      {{ account.account_name }}
                      <v-chip x-small outlined color="info">
                        {{ account.type }}
                      </v-chip>
                    </div>
                    <div class="body-1 ml-2">
                      {{ profile.email }}
                      <v-icon v-if="profile.email_verified" small color="green"> mdi-check-decagram </v-icon>
                    </div>
                  </div>
                </v-card-title>
              </v-col>
            </v-row>
            <v-row class="mx-2 mb-3">
              <v-col xs="12" md="6">
                <div class="d-flex flex-column">
                  <div class="my-2 ml-2">
                    <span v-for="item in accountRoles()" :key="item">
                      <v-chip color="primary" outlined> {{ item.toUpperCase() }} </v-chip>&nbsp;
                    </span>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-tabs v-model="tab" show-arrows>
              <v-tab v-for="tabItem in tabs" :href="'#' + tabItem.id" :key="tabItem.id" @click="tabClick(tabItem.id)">
                <v-icon size="20" class="me-3">
                  {{ tabItem.icon }}
                </v-icon>
                <span>{{ tabItem.title }}</span>
              </v-tab>

              <v-tab-item key="basicInformation" value="basicInformation">
                <v-form>
                  <v-card flat class="pa-4 mt-2">
                    <ValidationObserver ref="profileStep">
                      <v-row class="mt-4">
                        <v-col md="6" cols="12">
                          <ValidationProvider name="First Name" rules="is_numeric" v-slot="{ errors }">
                            <v-text-field
                              v-model="profile.first_name"
                              :label="$vuetify.lang.t('$vuetify.member.first_name')"
                              outlined
                              :error-messages="localizeErrorMsg(errors, 'first_name', profile.first_name)"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col md="6" cols="12">
                          <ValidationProvider name="Middle Name" rules="is_numeric" v-slot="{ errors }">
                            <v-text-field
                              v-model="profile.middle_name"
                              :label="$vuetify.lang.t('$vuetify.member.middle_name')"
                              outlined
                              :error-messages="localizeErrorMsg(errors, 'middle_name', profile.middle_name)"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col md="6" cols="12">
                          <ValidationProvider name="Last Name" rules="is_numeric" v-slot="{ errors }">
                            <v-text-field
                              v-model="profile.last_name"
                              :label="$vuetify.lang.t('$vuetify.member.last_name')"
                              outlined
                              :error-messages="localizeErrorMsg(errors, 'last_name', profile.last_name)"
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <v-col md="6" cols="12">
                          <ValidationProvider name="Email" rules="" v-slot="{ errors }">
                            <v-text-field
                              v-model="profile.email"
                              :label="$vuetify.lang.t('$vuetify.member.email')"
                              :error-messages="errors"
                              outlined
                              disabled
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                        <!-- date of birth  -->
                        <v-col md="6" cols="12">
                          <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <!-- mdi-cake-variant-outline -->
                            <template #activator="{ on, attrs }">
                              <ValidationProvider name="Date of Birth" rules="birth_date" v-slot="{ errors }">
                                <v-text-field
                                  v-model="date"
                                  :label="$vuetify.lang.t('$vuetify.profile.dob_label_txt')"
                                  prepend-icon=""
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  clearable
                                  :error-messages="errors"
                                ></v-text-field>
                              </ValidationProvider>
                            </template>
                            <v-date-picker
                              :max="new Date().toISOString().substr(0, 10)"
                              v-model="date"
                              no-title
                              scrollable
                            >
                              <v-spacer></v-spacer>
                              <v-btn text color="primary" @click="menu = false">
                                {{ $vuetify.lang.t("$vuetify.common.cancel_btn") }}
                              </v-btn>
                              <v-btn text color="primary" @click="$refs.menu.save(date)">
                                {{ $vuetify.lang.t("$vuetify.common.ok_btn") }}
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col md="6" cols="12">
                          <ValidationProvider name="Phone Number" rules="" v-slot="{ errors }">
                            <vue-tel-input-vuetify
                              v-model="profile.phone"
                              :errorMessages="localizeErrorMsg(errors, 'phone_no', profile.phone)"
                              @input="onInput"
                              mode="international"
                              placeholder=" "
                              :label="$vuetify.lang.t('$vuetify.profile.phone_no_label_txt')"
                              :disabledFetchingCountry="true"
                              outlined
                            ></vue-tel-input-vuetify>
                          </ValidationProvider>
                        </v-col>

                        <v-col md="6" cols="12">
                          <ValidationProvider name="Gender" rules="" v-slot="{ errors }">
                            <v-autocomplete
                              :label="$vuetify.lang.t('$vuetify.profile.gender_label_txt')"
                              :items="genderParams"
                              v-model="profile.gender"
                              item-text="text"
                              item-value="value"
                              :error-messages="errors"
                              outlined
                            ></v-autocomplete>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="6">
                          <ValidationProvider name="Country" rules="" v-slot="{ errors }">
                            <form autocomplete="off" @submit.prevent>
                              <v-autocomplete
                                :label="$vuetify.lang.t('$vuetify.profile.country_label_txt')"
                                v-model="profile.country"
                                :items="AllCountry"
                                item-text="countryName"
                                item-value="countryCode"
                                :error-messages="localizeErrorMsg(errors, 'country')"
                                outlined
                              ></v-autocomplete>
                            </form>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="6">
                          <ValidationProvider name="State" rules="" v-slot="{ errors }">
                            <form autocomplete="off" @submit.prevent>
                              <v-autocomplete
                                :label="$vuetify.lang.t('$vuetify.profile.state_label_txt')"
                                :items="
                                  AllCountry.filter(obj => obj.countryCode === profile.country)[0] &&
                                  AllCountry.filter(obj => obj.countryCode === profile.country)[0].regions
                                "
                                item-text="name"
                                item-value="name"
                                v-model="profile.region"
                                :error-messages="localizeErrorMsg(errors, 'state')"
                                outlined
                              ></v-autocomplete>
                            </form>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="6">
                          <ValidationProvider name="City" rules="is_numeric" v-slot="{ errors }">
                            <v-text-field
                              v-model="profile.city"
                              :label="$vuetify.lang.t('$vuetify.profile.city_label_txt')"
                              :error-messages="localizeErrorMsg(errors, 'city', profile.city)"
                              outlined
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="6">
                          <ValidationProvider
                            name="Postal Code"
                            mode="eager"
                            rules="postal_code:@Country"
                            v-slot="{ errors }"
                          >
                            <v-text-field
                              v-model="profile.postal_code"
                              :error-messages="localizeErrorMsg(errors, 'post_code', profile.postal_code)"
                              :label="$vuetify.lang.t('$vuetify.profile.post_code_label_txt')"
                              outlined
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="12" md="6">
                          <ValidationProvider name="Address" rules="is_numeric" v-slot="{ errors }">
                            <v-text-field
                              v-model="profile.address"
                              :error-messages="localizeErrorMsg(errors, 'address', profile.address)"
                              :label="$vuetify.lang.t('$vuetify.profile.address_label_txt')"
                              outlined
                            ></v-text-field>
                          </ValidationProvider>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" outlined large class="mr-2" type="reset" @click.prevent="resetForm">
                          {{ $vuetify.lang.t("$vuetify.common.cancel_btn") }}
                        </v-btn>
                        <v-btn color="primary" large @click="updateProfile" :loading="isUpdateProfile">
                          {{ $vuetify.lang.t("$vuetify.common.save_btn") }}
                        </v-btn>
                      </v-card-actions>
                    </ValidationObserver>
                  </v-card>
                </v-form>
              </v-tab-item>
              <v-tab-item key="accountInformation" value="accountInformation" v-if="showAccountInfo">
                <div>
                  <AccountInformation />
                </div>
              </v-tab-item>
              <v-tab-item v-if="showIDVerification">
                <v-form>
                  <v-card flat class="pa-4 mt-2">
                    <ValidationObserver ref="verifyStep">
                      <v-row>
                        <v-col md="12" cols="12">
                          <v-chip
                            v-if="organization.id_status === 'verified'"
                            class="text-capitalize"
                            outlined
                            medium
                            color="primary"
                          >
                            {{ organization.id_status }}
                          </v-chip>
                          <v-chip
                            v-else-if="organization.id_status === 'pending'"
                            class="text-capitalize"
                            outlined
                            medium
                            color="orange"
                          >
                            {{ organization.id_status }}
                          </v-chip>
                          <v-chip v-else class="text-capitalize" outlined medium color="red">
                            {{ organization.id_status }}
                          </v-chip>
                        </v-col>
                        <v-col cols="12" xs="12" md="12">
                          <v-label>
                            {{ $vuetify.lang.t("$vuetify.profile.id_verify_header_txt") }}
                          </v-label>
                        </v-col>
                        <v-col cols="12" md="6">
                          <!-- select image  -->
                          <v-row no-gutters>
                            <v-col cols="12" md="12">
                              <ValidationProvider name="Front Side" rules="image" ref="front_side" v-slot="{ errors }">
                                <v-file-input
                                  show-size
                                  :label="$vuetify.lang.t('$vuetify.profile.upload_img_1_label_txt')"
                                  accept="image/*"
                                  @change="selectImage"
                                  outlined
                                  :disabled="isDisabled()"
                                  :error-messages="localizeErrorMsg(errors, 'upload_img_1')"
                                >
                                </v-file-input>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <!-- Image Preview -->
                          <v-row>
                            <v-col cols="12" v-if="previewImage">
                              <div v-if="progress">
                                <div>
                                  <v-progress-linear v-model="progress" color="primary" height="25" reactive>
                                    <strong>{{ progress }} %</strong>
                                  </v-progress-linear>
                                </div>
                              </div>

                              <div>
                                <v-img class="preview my-3" aspect-ratio="2" contain :src="previewImage" alt=""></v-img>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="12" md="6">
                          <!-- select image id back  -->
                          <v-row no-gutters>
                            <v-col cols="12" md="12">
                              <ValidationProvider name="Back Side" rules="image" ref="back_side" v-slot="{ errors }">
                                <v-file-input
                                  show-size
                                  :label="$vuetify.lang.t('$vuetify.profile.upload_img_2_label_txt')"
                                  accept="image/*"
                                  @change="selectImageBack"
                                  outlined
                                  :disabled="isDisabled()"
                                  :error-messages="localizeErrorMsg(errors, 'upload_img_2')"
                                >
                                </v-file-input>
                              </ValidationProvider>
                            </v-col>
                          </v-row>
                          <!-- Image Preview -->
                          <v-row>
                            <v-col cols="12" v-if="previewImageBack">
                              <div v-if="progressBack">
                                <div>
                                  <v-progress-linear v-model="progressBack" color="primary" height="25" reactive>
                                    <strong>{{ progressBack }} %</strong>
                                  </v-progress-linear>
                                </div>
                              </div>

                              <div>
                                <v-img
                                  class="preview my-3"
                                  aspect-ratio="2"
                                  contain
                                  :src="previewImageBack"
                                  alt=""
                                ></v-img>
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="error" outlined large class="mr-2" type="reset" @click.prevent="resetForm">
                          {{ $vuetify.lang.t("$vuetify.common.cancel_btn") }}
                        </v-btn>
                        <v-btn color="primary" large :disabled="isDisabled()" :loading="uploading" @click="upload">
                          {{ $vuetify.lang.t("$vuetify.common.upload_btn") }}
                        </v-btn>
                      </v-card-actions>
                    </ValidationObserver>
                  </v-card>
                </v-form>
              </v-tab-item>
              <v-tab-item key="settings" value="settings">
                <!-- change password implementation  -->
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card flat outlined>
                    <v-row class="px-5 py-5">
                      <v-col cols="12" class="pb-6">
                        <div class="text-h6">
                          {{ $vuetify.lang.t("$vuetify.profile.change_password_title") }}
                        </div>
                        <div class="text-body-2 grey--text text--darken-1 mt-1">
                          {{ $vuetify.lang.t("$vuetify.profile.change_password_subtitle") }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-text-field
                          :label="$vuetify.lang.t('$vuetify.registration.current_password_label_txt')"
                          v-model="oldPassword"
                          :placeholder="$vuetify.lang.t('$vuetify.registration.current_password_label_txt')"
                          outlined
                          :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showCurrentPassword ? 'text' : 'password'"
                          :rules="currentPasswordRules()"
                          @click:append="showCurrentPassword = !showCurrentPassword"
                          @input="$refs.newPasswordField?.validate()"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :label="$vuetify.lang.t('$vuetify.registration.new_password_label_txt')"
                          v-model="newPassword"
                          :placeholder="$vuetify.lang.t('$vuetify.registration.new_password_label_txt')"
                          outlined
                          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showPassword ? 'text' : 'password'"
                          :rules="newPasswordRules()"
                          @click:append="showPassword = !showPassword"
                          ref="newPasswordField"
                          @input="
                            $refs.newPasswordField && $refs.newPasswordField.validate();
                            $refs.confirmPasswordField && $refs.confirmPasswordField.validate();
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="6">
                        <v-text-field
                          :label="$vuetify.lang.t('$vuetify.registration.re_password_label_txt')"
                          v-model="confirmNewPassword"
                          :placeholder="$vuetify.lang.t('$vuetify.registration.re_password_label_txt')"
                          outlined
                          :append-icon="showRePassword ? 'mdi-eye' : 'mdi-eye-off'"
                          :type="showRePassword ? 'text' : 'password'"
                          :rules="confirmPasswordRules()"
                          @click:append="showRePassword = !showRePassword"
                          ref="confirmPasswordField"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="error" outlined large class="mr-2" type="reset" @click="dialog = false">
                        {{ $vuetify.lang.t("$vuetify.common.cancel_btn") }}
                      </v-btn>
                      <v-btn
                        color="primary"
                        large
                        :loading="updateDisabled"
                        :disabled="isPasswordSaveDisabled || updateDisabled"
                        @click="updatePassword"
                      >
                        {{ $vuetify.lang.t("$vuetify.common.save_btn") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>

                <v-card flat outlined class="mt-4">
                  <v-row class="px-5 py-5" align="center">
                    <v-col cols="12" class="pb-6">
                      <div class="text-h6">
                        {{ $vuetify.lang.t("$vuetify.profile.notification_sound_title") }}
                      </div>
                      <div class="text-body-2 grey--text text--darken-1 mt-1">
                        {{ $vuetify.lang.t("$vuetify.profile.notification_sound_subtitle") }}
                      </div>
                      <div
                        class="info-notice mt-2 pl-1 d-flex align-center flex-wrap"
                        v-if="profile.notification_sound_enabled"
                      >
                        <v-icon small color="info" class="mr-1">mdi-information</v-icon>
                        <span class="info-notice-text">
                          {{ $vuetify.lang.t("$vuetify.profile.notification_sound_autoplay_info") }}
                        </span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" class="d-flex align-center">
                      <v-switch
                        v-model="profile.notification_sound_enabled"
                        hide-details
                        class="ma-0 pa-0"
                      >
                        <template #label>
                          <span class="d-flex align-center">
                            {{ $vuetify.lang.t("$vuetify.profile.notification_sound_enabled_label") }}
                            <v-tooltip bottom max-width="300">
                              <template #activator="{ on, attrs }">
                                <span class="info-icon" v-bind="attrs" v-on="on">i</span>
                              </template>
                              <span>
                                {{ $vuetify.lang.t("$vuetify.profile.notification_sound_enabled_hint") }}
                              </span>
                            </v-tooltip>
                          </span>
                        </template>
                      </v-switch>
                    </v-col>
                    <v-col cols="12" md="5">
                      <v-select
                        v-model="profile.notification_ringtone"
                        :items="ringtoneOptions"
                        item-text="text"
                        item-value="value"
                        :label="$vuetify.lang.t('$vuetify.profile.notification_ringtone_label')"
                        outlined
                        hide-details
                        :disabled="!profile.notification_sound_enabled"
                        @change="playTestSound"
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="d-flex align-center">
                      <v-btn
                        color="primary"
                        outlined
                        :disabled="!profile.notification_sound_enabled"
                        @click="playTestSound"
                      >
                        <v-icon left small>mdi-volume-high</v-icon>
                        {{ $vuetify.lang.t("$vuetify.profile.notification_test_sound_btn") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="primary"
                      large
                      :loading="isUpdateProfile"
                      @click="updateNotificationSettings"
                    >
                      {{ $vuetify.lang.t("$vuetify.common.save_btn") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
              <v-tab-item key="access_control" value="access_control" v-if="organization.is_account_owner">
                <v-card flat class="pa-2 pt-2 mt-2">
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="showMembersToOthers"
                      :items="showMemberOptions"
                      :label="$vuetify.lang.t('$vuetify.profile.show_members_to_others')"
                      outlined
                      :hint="$vuetify.lang.t('$vuetify.profile.show_members_to_others_hint')"
                      persistent-hint
                    ></v-select>
                  </v-col>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn
                      color="error"
                      outlined
                      large
                      class="mr-2"
                      type="reset"
                      @click.prevent="resetForm"
                      :disabled= "accountType !== 'organization'"
                    >
                      {{ $vuetify.lang.t("$vuetify.common.cancel_btn") }}
                    </v-btn> -->
                    <v-btn color="primary" large @click="updateAccount" :loading="isUpdatingAccount">
                      {{ $vuetify.lang.t("$vuetify.common.save_btn") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <Modal
      v-model="alertDialog"
      :title="alertTitle"
      :message="alertMessage"
      confirmButtonText="Ok"
      :cancelButton="false"
      @onConfirmation="alertDialog = false"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import validations from "@/helpers/validations";
import { playNotificationSound, RINGTONE_OPTIONS } from "@/helpers/notificationSound";
import {
  CHANGE_USER_PASSWORD,
  LOAD_ORGANIZATION,
  EDIT_USER_PROFILE,
  ADD_ALERT,
  SAVE_CONTENT,
  UPLOAD_USER_ID,
  PATCH_ACCOUNT_SETTINGS,
} from "@/store/_actiontypes";

import { PASSWORD } from "@/components/common/input/_inputTypes";

import { RAISED_BUTTON, TEXT_BUTTON } from "@/components/common/button/_buttontypes";

import Modal from "@/components/common/modal/Modal";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import "@/helpers/vee-validate";
import { AllCountry } from "vuetify-country-search";
import AccountInformation from "@/components/MyProfile/AccountInformation";
import Loader from "@/components/common/loader/Loader";
import { Role } from "@/helpers/role";
import { authorize } from "@/helpers/helper";
import jwt_decode from "jwt-decode";

export default {
  components: {
    Modal,
    AccountInformation,
    ValidationObserver,
    ValidationProvider,
    Loader,
  },
  props: {
    genderParams: {
      type: Array,
      default() {
        return [
          {
            text: this.$vuetify.lang.t("$vuetify.profile.male_label_txt"),
            value: "male",
          },
          {
            text: this.$vuetify.lang.t("$vuetify.profile.female_label_txt"),
            value: "female",
          },
          {
            text: this.$vuetify.lang.t("$vuetify.profile.other_label_txt"),
            value: "other",
          },
        ];
      },
    },
  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      organization: state => state.account.organization,
      account: state => state.account.account,
    }),
    tabs() {
      let initialTabs = [
        {
          id: "basicInformation",
          title: this.$vuetify.lang.t("$vuetify.profile.profile_basic_tab"),
          icon: "mdi-account",
        },
        {
          id: "accountInformation",
          title: this.$vuetify.lang.t("$vuetify.profile.profile_account_tab"),
          icon: "mdi-account-outline",
        },
        // remove profile verification.
        // {
        //   id: 2,
        //   title: this.$vuetify.lang.t("$vuetify.profile.profile_verify_tab"),
        //   icon: "domain_verification",
        // },
        {
          id: "settings",
          title: this.$vuetify.lang.t("$vuetify.profile.profile_settings_tab"),
          icon: "mdi-cog",
        },
      ];

      if (this.organization.is_account_owner) {
        initialTabs.push({
          id: "access_control",
          title: this.$vuetify.lang.t("$vuetify.access_control.title"),
          icon: "admin_panel_settings",
        });
      }
      return initialTabs;
    },
    size() {
      const size = { xs: "large", sm: "large", lg: "large", xl: "x-large" }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    isPasswordSaveDisabled() {
      if (!this.oldPassword) return true;
      if (!this.newPassword) return true;
      if (!this.confirmNewPassword) return true;

      const newPasswordValid = this.newPasswordRules().every(rule => rule(this.newPassword) === true);

      if (!newPasswordValid) return true;

      const confirmPasswordValid = this.confirmPasswordRules().every(rule => rule(this.confirmNewPassword) === true);

      if (!confirmPasswordValid) return true;

      return false;
    },
  },
  created() {
    this.showAccountInfo = authorize([Role.ADMIN]);
    if (!this.showAccountInfo) {
      this.tabs.splice(1, 1);
    }
    this.tab = this.$route.query.tab ? this.$route.query.tab : "basicInformation";
    this.getProfileData();
  },
  data() {
    return {
      PASSWORD: PASSWORD,
      RAISED_BUTTON: RAISED_BUTTON,
      TEXT_BUTTON: TEXT_BUTTON,
      loading: false,
      profileLoading: true,
      showCurrentPassword: false,
      showPassword: false,
      showRePassword: false,
      authorize,
      showMembersToOthers: false,
      profile: {
        first_name: "",
        middle_name: "",
        last_name: "",
        gender: "",
        phone: "",
        logo: "",
        country: "",
        region: "",
        city: "",
        postal_code: "",
        address: "",
        roles: "",
        notification_sound_enabled: false,
        notification_ringtone: "default",
      },
      savedProfile: null,
      ...validations,
      dialog: false,
      updateDisabled: false,
      oldPassword: null,
      newPassword: null,
      confirmNewPassword: null,
      alertDialog: false,
      alertTitle: "Error",
      alertMessage: "Unknown error occurs",
      saveClicked: false,
      valid: true,
      tab: "accountInformation",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
      menu: false,
      AllCountry,
      currentImage: undefined,
      previewImage: undefined,
      id_img_key: null,
      progress: 0,
      disableUpload: false,
      currentImageBack: undefined,
      previewImageBack: undefined,
      id_img_key_back: null,
      progressBack: 0,
      disableUploadBack: false,
      identity_type: "ID",
      uploadedNumber: 0,
      isUpdateProfile: false,
      uploading: false,
      showAccountInfo: false,
      showIDVerification: false,
      isUpdatingAccount: false,
      isAccessControlLoaded: false,
      showMemberOptions: [
        {
          text: this.$vuetify.lang.t("$vuetify.profile.enabled_dropdown"),
          value: true,
        },
        {
          text: this.$vuetify.lang.t("$vuetify.profile.disabled_dropdown"),
          value: false,
        },
      ],
      archiveConversationsOptions: [
        {
          text: this.$vuetify.lang.t('$vuetify.profile.enabled_dropdown'),
          value: true
        },
        {
          text: this.$vuetify.lang.t('$vuetify.profile.disabled_dropdown'),
          value: false
        }
      ],
      ringtoneOptions: RINGTONE_OPTIONS
    };
  },
  watch: {
    account: {
      immediate: true,
      handler(newVal) {
        if (this.isAccessControlLoaded || !newVal) return;
        this.showMembersToOthers = newVal.show_members_to_others;
        this.isAccessControlLoaded = true;
      },
    },
  },
  methods: {
    ...mapActions("account", [
      CHANGE_USER_PASSWORD,
      LOAD_ORGANIZATION,
      EDIT_USER_PROFILE,
      UPLOAD_USER_ID,
      PATCH_ACCOUNT_SETTINGS,
    ]),
    ...mapActions("alert", [ADD_ALERT]),
    ...mapActions("upload", [SAVE_CONTENT]),
    localizeErrorMsg() {
      if (arguments[0] && arguments[0].length && arguments[1] && !arguments[2]) {
        return this.$vuetify.lang.t(`$vuetify.profile.${arguments[1]}_error_msg_txt`);
      }
      if (arguments[0] && arguments[0].length && arguments[1] && arguments[2]) {
        return this.$vuetify.lang.t(`$vuetify.profile.${arguments[1]}_error_msg_txt_2`);
      }
    },
    getProfileData() {
      this.LOAD_ORGANIZATION()
        .then(res => {
          this.profileLoading = false;
          let data = res.data;
          this.savedProfile = data;
          this.profile = {
            first_name: data.first_name,
            middle_name: data.middle_name,
            last_name: data.last_name,
            email: data.email,
            email_verified: data.email_verified,
            gender: data.gender,
            phone: data.phone,
            phone_verified: data.phone_verified,
            logo: data.photo,
            country: data.country_code,
            region: data.state_or_province,
            city: data.city,
            postal_code: data.postal_code,
            address: data.address,
            notification_sound_enabled: data.notification_sound_enabled ?? false,
            notification_ringtone: data.notification_ringtone || "default",
            // roles: data.roles[0].name,
          };
          this.date = data.birth_date;
          // this.previewImage = data.photo_id_front;
          // this.previewImageBack = data.photo_id_back;
        })
        .catch(err => err);
    },
    //let's update user details
    updateProfile() {
      this.$refs.profileStep.validate().then(success => {
        if (!success) {
          return;
        }
        const { first_name, middle_name, last_name, phone, gender, country, region, city, postal_code, address, logo } =
          this.profile;

        const userData = {
          first_name: first_name || "",
          last_name: last_name || "",
          ...(middle_name && { middle_name }),
          ...(phone && { phone: String(phone).replaceAll(" ", "") }),
          ...(this.date && { birth_date: this.date }),
          ...(logo && { photo: logo }),
          ...(gender && { gender }),
          ...(country && { country_code: country }),
          ...(country && region && { state_or_province: region }),
          ...(city && { city }),
          ...(postal_code && { postal_code }),
          ...(address && { address }),
        };
        this.isUpdateProfile = true;
        this.EDIT_USER_PROFILE({ userData })
          .then(() => {
            this.$store.dispatch(
              `alert/${ADD_ALERT}`,
              {
                message: this.$vuetify.lang.t("$vuetify.account.acc_update_msg_txt"),
                color: "success",
              },
              { root: true }
            );
            this.isUpdateProfile = false;
            this.getProfileData();
          })
          .catch(() => {
            this.isUpdateProfile = false;
          });
      });
    },
    updateNotificationSettings() {
      const {
        notification_sound_enabled,
        notification_ringtone
      } = this.profile;

      this.isUpdateProfile = true;
      this.LOAD_ORGANIZATION()
        .then((res) => {
          const saved = res.data;
          this.savedProfile = saved;
          const userData = {
            first_name: saved.first_name ?? '',
            last_name: saved.last_name ?? '',
            ...(saved.middle_name && { middle_name: saved.middle_name }),
            ...(saved.phone && { phone: String(saved.phone).replaceAll(" ", "") }),
            ...(saved.birth_date && { birth_date: saved.birth_date }),
            ...(saved.photo && { photo: saved.photo }),
            ...(saved.gender && { gender: saved.gender }),
            ...(saved.country_code && { country_code: saved.country_code }),
            ...(saved.country_code && saved.state_or_province && { state_or_province: saved.state_or_province }),
            ...(saved.city && { city: saved.city }),
            ...(saved.postal_code && { postal_code: saved.postal_code }),
            ...(saved.address && { address: saved.address }),
            notification_sound_enabled: !!notification_sound_enabled,
            notification_ringtone: notification_ringtone || "default"
          };
          return this.EDIT_USER_PROFILE({ userData }).then(() => saved);
        })
        .then((saved) => {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t("$vuetify.profile.notification_settings_updated_msg"),
              color: "success",
            },
            { root: true }
          );
          this.isUpdateProfile = false;
          this.savedProfile = {
            ...saved,
            notification_sound_enabled: !!notification_sound_enabled,
            notification_ringtone: notification_ringtone || "default",
          };
          this.$store.commit("account/SET_ORGANIZATION", this.savedProfile);
        })
        .catch((err) => {
          this.isUpdateProfile = false;
          this.profile.notification_sound_enabled = this.savedProfile?.notification_sound_enabled ?? false;
          this.profile.notification_ringtone = this.savedProfile?.notification_ringtone || "default";
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: err?.response?.data?.message || this.$vuetify.lang.t("$vuetify.common.unknown_err_msg_txt"),
              color: "error",
            },
            { root: true }
          );
        });
    },
    playTestSound() {
      if (!this.profile.notification_sound_enabled) return;
      playNotificationSound(this.profile.notification_ringtone, true);
    },
    changePasswordClick() {
      this.resetForm();
      this.saveClicked = false;
      this.dialog = true;
    },
    updatePassword() {
      if (!this.$refs.form.validate()) return;
      this.saveClicked = true;
      if (this.newPassword !== this.confirmNewPassword) return;
      this.updatePasswordAction();
    },
    updatePasswordAction() {
      this.updateDisabled = true;
      this.CHANGE_USER_PASSWORD({
        old_password: this.oldPassword,
        new_password: this.newPassword,
      }).then(
        () => {
          this.updateDisabled = false;
        },
        error => {
          this.updateDisabled = false;
          this.showErrorModal(error);
        }
      );
    },
    saveID() {
      let userData = {
        photo_id_front: this.id_img_key,
        photo_id_back: this.id_img_key_back,
      };
      this.UPLOAD_USER_ID({ userData })
        .then(() => {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t("$vuetify.profile.id_upload_success_msg_txt"),
              color: "success",
            },
            { root: true }
          );
          this.getProfileData();
          this.uploadedNumber = 0;
          this.uploading = false;
        })
        .catch(() => {
          this.uploading = false;
        });
    },
    saveIDHandle() {
      if (this.uploadedNumber >= 2) {
        this.saveID();
      }
    },
    showErrorModal(error) {
      this.alertTitle = "Error";
      if (error.response && error.response.status) {
        this.alertTitle += ": " + error.response.status;
      }
      let errormessage = error.response && error.response.data.message ? error.response.data.message : error.message;
      if (errormessage) {
        this.alertMessage = errormessage;
      } else {
        this.alertMessage = "Unknown Error!";
      }
      this.alertDialog = true;
    },
    validateForm() {
      this.$refs.form.validate();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    resetForm() {},
    onInput(formattedNumber, { number, valid }) {
      this.profile.phone = number.international;
    },
    async selectImage(image) {
      const { valid } = await this.$refs.front_side.validate(image);
      this.currentImage = image;
      if (image === null) {
        this.previewImage = undefined;
      } else {
        this.previewImage = URL.createObjectURL(this.currentImage);
      }
      this.progress = 0;
    },
    // upload
    upload() {
      this.$refs.verifyStep.validate().then(success => {
        if (!success) {
          return;
        }
        this.uploading = true;
        this.uploadedNumber = 0;
        this.uploadFront();
        this.uploadBack();
      });
    },
    // upload front
    uploadFront() {
      if (!this.currentImage) {
        this.alertMessage = "Please select both front and back side of your ID!";
        this.alertDialog = true;
        return;
      }
      this.disableUpload = true;
      this.progress = 0;
      this.SAVE_CONTENT({
        formData: this.currentImage,
        content_type: "identity",
        identity_type: this.identity_type,
        identity_side: "front",
        onUploadProgress: event => {
          this.progress = Math.round((100 * event.loaded) / event.total);
        },
      })
        .then(res => {
          this.previewImage = res.data.details.url;
          this.id_img_key = res.data.details.key;
          this.disableUpload = false;
          this.uploadedNumber++;
          this.saveIDHandle();
        })
        .catch(err => {
          this.disableUpload = false;
          this.uploading = false;
        });
    },
    async selectImageBack(image) {
      const { valid } = await this.$refs.back_side.validate(image);
      this.currentImageBack = image;
      if (image === null) {
        this.previewImageBack = undefined;
      } else {
        this.previewImageBack = URL.createObjectURL(this.currentImageBack);
      }
      this.progressBack = 0;
    },
    // upload back
    uploadBack() {
      if (!this.currentImageBack) {
        this.alertMessage = "Please select both front and back side of your ID!";
        this.alertDialog = true;
        return;
      }
      this.disableUploadBack = true;
      this.progressBack = 0;
      this.SAVE_CONTENT({
        formData: this.currentImageBack,
        content_type: "identity",
        identity_type: this.identity_type,
        identity_side: "back",
        onUploadProgress: event => {
          this.progressBack = Math.round((100 * event.loaded) / event.total);
        },
      })
        .then(res => {
          this.previewImageBack = res.data.details.url;
          this.id_img_key_back = res.data.details.key;
          this.disableUploadBack = false;
          this.uploadedNumber++;
          this.saveIDHandle();
        })
        .catch(() => {
          this.disableUploadBack = false;
          this.uploading = false;
        });
    },

    isDisabled() {
      if (this.organization.id_status === "pending") {
        return true;
      } else if (this.organization.id_status === "verified") {
        return true;
      } else {
        return false;
      }
    },
    accountRoles() {
      return jwt_decode(this.user.access_token)["scope"];
    },
    tabClick(id) {
      const currentTab = this.$route.query.tab;
      if (currentTab !== id) {
        this.$router.push({ path: "/profile-settings", query: { tab: id } });
        if (id === "access_control") {
          this.syncAccessControlFields();
        }
      }
    },
    syncAccessControlFields() {
      if (!this.account) return;
      this.showMembersToOthers = this.account.show_members_to_others;
      this.isAccessControlLoaded = true;
    },
    updateAccount() {
      this.isUpdatingAccount = true;
      let show_members_to_others = this.showMembersToOthers;
      this.PATCH_ACCOUNT_SETTINGS({ show_members_to_others })
        .then(_res => {
          this.syncAccessControlFields();
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t("$vuetify.account.acc_update_msg_txt"),
              color: "success",
            },
            { root: true }
          );
        })
        .catch(err => {
          this.showMembersToOthers = this.account.show_members_to_others;
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: err.message,
              color: "error",
            },
            { root: true }
          );
        })
        .finally(() => {
          this.isUpdatingAccount = false;
        });
    },

    currentPasswordRules() {
      return [v => !!v || this.$vuetify.lang.t("$vuetify.registration.current_password_error_msg_txt")];
    },

    newPasswordRules() {
      return [
        this.required(this.$vuetify.lang.t("$vuetify.registration.password_label_txt")),
        v => v !== this.oldPassword || this.$vuetify.lang.t("$vuetify.registration.new_password_error_msg_txt_2"),

        this.password(this.$vuetify.lang.t("$vuetify.registration.password_label_txt")),
        this.passwordWithEmail(this.$vuetify.lang.t("$vuetify.registration.password_label_txt"), this.profile?.email),
        this.validatePasswordWithName(),
      ];
    },

    validatePasswordWithName() {
      return validations.passwordWithName(
        this.$vuetify.lang.t("$vuetify.registration.password_label_txt"),
        this.profile.first_name,
        this.$vuetify.lang.t("$vuetify.registration.name_header_txt")
      );
    },

    confirmPasswordRules() {
      return [
        v => !!v || this.$vuetify.lang.t("$vuetify.registration.re_password_error_msg_txt"),

        v => v === this.newPassword || this.$vuetify.lang.t("$vuetify.validation.password_confirm_error_msg_txt"),
      ];
    },
  },
};
</script>

<style scoped>
.info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  line-height: 18px;
  text-align: center;
  border-radius: 50%;
  background-color: #e0e0e0;
  color: #333;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  margin-left: 8px;
  pointer-events: auto;
}

.info-notice {
  color: #555;
  font-size: 14px;
}
.info-notice .v-icon {
  align-self: flex-start;
  margin-top: 2px;
}
.info-notice-text {
  align-self: flex-start;
  flex: 1 1 0;
  min-width: 0;
}
</style>
